/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var AT_Main = {
	
	getWidthBrowser : function() { // Get width browser
		var myWidth;

		if( typeof( window.innerWidth ) == 'number' ) {
			//Non-IE 
			myWidth = window.innerWidth;
		} 
		else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
			//IE 6+ in 'standards compliant mode' 
			myWidth = document.documentElement.clientWidth; 
		} 
		else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
			//IE 4 compatible 
			myWidth = document.body.clientWidth;  
		}

		return myWidth;
	}
	,checkLayout : function() { // Function to check level of layout
		if(jQuery("#checkLayout .visible-xs-block").css("display") == "block")
			return 1; //mobile layout
		else if(jQuery("#checkLayout .visible-sm-block").css("display") == "block")
			return 2; //tablet potrait layout
		else if(jQuery("#checkLayout .visible-md-block").css("display") == "block")
			return 3; //tablet landscape/medium desktop layout
		else if(jQuery("#checkLayout .visible-lg-block").css("display") == "block")
			return 4; //desktop layout
	}
	,stickMenu : function() {
		var enable_stick = jQuery(".header-content").data('stick');
		if(enable_stick){
		  //Keep track of last scroll
			var lastScroll = 0;
			var header = jQuery(".header-bot");
			var body_content = jQuery("#body-content");

			jQuery(window).scroll(function() {
				//Sets the current scroll position
				var st = jQuery(this).scrollTop();
				//Determines up-or-down scrolling
				if (st > lastScroll) {
					
					//Replace this with your function call for downward-scrolling
					if (st > 250 ) {
						header.addClass("header-fixed fadeIn animated");
						body_content.addClass("has-header-fixed");
					}
				}
				else {
					//Replace this with your function call for upward-scrolling
					if (st < 250) {
						header.removeClass("header-fixed fadeIn animated");
						body_content.removeClass("has-header-fixed");
					}
				}
				//Updates scroll position
				lastScroll = st;
			});
		}

	}
	
	,toTopButton : function(){
		var to_top_btn = $("#scroll-to-top");
		if( 1 > to_top_btn.length ){
			return;
		}
		$(window).on( 'scroll' , function() {
			var b = jQuery(this).scrollTop();
			var c = jQuery(this).height();
			if (b > 100) { 
				var d = b + c / 2;
			}
			else { 
				var d = 1 ;
			}

			if (d < 1000 && d < c) { 
				jQuery("#scroll-to-top").removeClass('on off').addClass('off'); 
			} else {
				jQuery("#scroll-to-top").removeClass('on off').addClass('on'); 
			}
		});

		to_top_btn.on( 'click',function (e) {
			e.preventDefault();
			jQuery('body,html').animate({scrollTop:0},800,'swing');
		});
	}

	,mailchipPopup : function(){
		var expire = jQuery("#mailchimp-popup").data('expires');
		if (jQuery.cookie('mycookie')) {
			//it hasn't been one days yet
		}
		else {
			jQuery.fancybox(
				jQuery('#mailchimp-popup'),
				{
					'autoDimensions': false
					,'width'		: 730
					,'height'		: 390
					,'autoSize' 	: false
					,'transitionIn'	: 'none'
					,'transitionOut': 'none'

				}
			);
		}
		jQuery.cookie('mycookie', 'true', { expires: expire });
	}
  
    ,handleGridList: function() {
      
      	if ($.cookie('cata-grid-extended') == "yes") {
            $("body").addClass("cata-grid-extended");
        }

        if ($.cookie('cata-list') == "yes") {
            $("body").addClass("cata-list");
        }
      
      	if ($.cookie('cata-list-small') == "yes") {
            $("body").addClass("cata-list-small");
        }

        jQuery("body").on("click", ".grid", function() {
            var e = jQuery(this).closest(".grid-list");
          	$.cookie('cata-grid-extended','no',  {expires: 1, path: '/'});
            $.cookie('cata-list','no',  {expires: 1, path: '/'});
          	$.cookie('cata-list-small','no',  {expires: 1, path: '/'});
          	jQuery("body").removeClass("cata-grid-extended");
          	jQuery("body").removeClass("cata-list");
          	jQuery("body").removeClass("cata-list-small");
        }),jQuery("body").on("click", ".grid-extended", function() {
            var e = jQuery(this).closest(".grid-list");
            $.cookie('cata-list','no',  {expires: 1, path: '/'});
          	$.cookie('cata-list-small','no',  {expires: 1, path: '/'});
          	$.cookie('cata-grid-extended','yes', {expires: 1, path: '/'});
          	jQuery("body").removeClass("cata-list");
          	jQuery("body").removeClass("cata-list-small");
          	jQuery("body").addClass("cata-grid-extended");
        }),jQuery("body").on("click", ".list", function() {
            var e = jQuery(this).closest(".grid-list");
          	$.cookie('cata-grid-extended','no',  {expires: 1, path: '/'});
          	$.cookie('cata-list-small','no',  {expires: 1, path: '/'});
            $.cookie('cata-list','yes', {expires: 1, path: '/'});
          	jQuery("body").removeClass("cata-grid-extended");
          	jQuery("body").removeClass("cata-list-small");
          	jQuery("body").addClass("cata-list");
        }),jQuery("body").on("click", ".list-small", function() {
            var e = jQuery(this).closest(".grid-list");
          	$.cookie('cata-grid-extended','no',  {expires: 1, path: '/'});
          	$.cookie('cata-list','no',  {expires: 1, path: '/'});
            $.cookie('cata-list-small','yes', {expires: 1, path: '/'});
          	jQuery("body").removeClass("cata-grid-extended");
          	jQuery("body").removeClass("cata-list");
          	jQuery("body").addClass("cata-list-small");
        })
    }
  
  	,effectNavigation : function(){ // Make hover effect of navigation
		jQuery(".horizontal-menu .navigation .navbar-collapse .main-nav>li").hover(function(e){
			jQuery(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').addClass("fadeInUp animated");
		},function(e){
			jQuery(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').removeClass("fadeInUp animated");
		});
      
      	jQuery(".vertical-menu .navigation .navbar-collapse .main-nav>li").hover(function(e){
			jQuery(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').addClass("fadeInRight animated");
		},function(e){
			jQuery(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').removeClass("fadeInRight animated");
		});
      
      	jQuery(".cart-target").hover(function(e){
			jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
		},function(e){
			jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
		});
      
      	jQuery(".currency-block").hover(function(e){
			jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
		},function(e){
			jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
		});
	}

	,fixNoScroll : function() { // Fixed persitent position of page when scroll disapear
		var windowW = jQuery(window).width();
		jQuery('#page-body, .header-content, #page-body .mobile-version').css("width", windowW + 'px');
	}

	,fixReturnScroll : function() {
		jQuery('#page-body, .header-content,#page-body .mobile-version').attr('style', ''); 
	}

  	,fixButton : function(){
      	jQuery(".product-wrapper .product-head").each(function(e){
            if($(this).children().hasClass('wrapper-countdown')){
              	$(this).find('.product-button').addClass('fix');
            }
  		});
    }
  
  	,handleReviews: function() {
        SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
    }
    
	,menuOnMobile : function(){
		jQuery('#page-body').on('click',function () {
			jQuery(".menu-mobile").removeClass("opened");
			jQuery("html,body").removeClass("menu-opened");
			AT_Main.fixReturnScroll();
		});

		jQuery(document).on('click','[data-toggle=offcanvas]',function(e){
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery(".menu-mobile").toggleClass("opened");
			jQuery("html,body").toggleClass("menu-opened")
		});

		jQuery(".navbar .main-nav li").hover(function(){jQuery(this).addClass("hover")},function(){jQuery(this).removeClass("hover")});


		jQuery(document).on('click','.mobile-version .menu-mobile .main-nav .expand',function(){
			var e=jQuery(this).parents(".dropdown").first();
            if (e.hasClass("menu-mobile-open")) {
                e.removeClass("menu-mobile-open");
                $(this).find('.visible-xs').removeClass('fa-minus');
                $(this).find('.visible-xs').addClass('fa-plus');
            } else {
                e.addClass("menu-mobile-open");
              	$(this).find('.visible-xs').removeClass('fa-plus');
                $(this).find('.visible-xs').addClass('fa-minus');
            }
		})
        
        jQuery(document).on('click','.sb-categories .s-expand',function(){
			var e=jQuery(this).parents(".dropdown").first();
            if (e.hasClass("s-open")) {
                e.removeClass("s-open");
                $(this).find('.s-plus').removeClass('fa-angle-up');
                $(this).find('.s-plus').addClass('fa-angle-right');
            } else {
                e.addClass("s-open");
              	$(this).find('.s-plus').removeClass('fa-angle-right');
                $(this).find('.s-plus').addClass('fa-angle-up');
            }
		})

	}
	
	,handleMenuMultiLine : function() {
		var outItem = "";
		var down = false;

		var top = 0;

		jQuery(".navbar-collapse .main-nav > li").on("mousemove", function(e){
			var target = jQuery(e.currentTarget);

			if( down && outItem != "") {
				outItem.addClass("hold");
				setTimeout(function(){
					if(outItem != "")
					outItem.removeClass("hold");
					down = false;
					outItem = "";
				},500);

				if( (outItem[0] == target[0]) || (outItem.offset().top == target.offset().top) )
				{       
					outItem.removeClass("hold");
					down = false;
					outItem = "";
				}
			}
			else {
				outItem = "";
			}

		});

		jQuery(".navbar-collapse .main-nav >li").on("mouseout", function(e){

			var target = jQuery(e.currentTarget);

			if( e.pageY >= target.offset().top + 50 ) { //move down
				down = true;
			}

			if( target.hasClass("dropdown") ) { //target has child

				if(outItem == "")
					outItem = target;
			}

		});
	}

	,toggleFilterSidebar : function(){
		jQuery(document).on('click', '.filter-toggle', function(e) {
            e.stopPropagation();
            AT_Main.fixNoScroll();
            jQuery('.sbw-filter').toggleClass('opened');
            jQuery('html,body').toggleClass('filter-opened');
		});

		jQuery(document).on('click', '#page-body', function(e) {
            jQuery('.sbw-filter').removeClass('opened');
            jQuery('html,body').removeClass('filter-opened');
		});
	}
 
	,dropdownFilter : function(){ // Show,hide advanced-filters in catalog page
		jQuery(document).on('click','.sb-filter .sbf-title>span',function(e){
			e.stopPropagation();
			jQuery(this).toggleClass('none-active');
			jQuery(this).closest('.sb-filter').find('.advanced-filters').toggleClass('hide');
		});
	}
  
  	,toggleFooter : function(){
        jQuery(document).on('click', '.footer-block h3>span', function(e) {
          jQuery(this).closest('.footer-block').find('h3').toggleClass('opened');
          jQuery(this).closest('.footer-block').find('.list-links').slideToggle();
        });
	}
  
  	,toggleVerticalMenu : function(){
        jQuery(document).on('click', '.vertical-menu .head', function(e) {
          jQuery(this).parent().toggleClass('opened');
          jQuery(this).parent().find('.navbar').slideToggle();
        });
	}
	
	,fixTitle : function(){ // fix title a in filter
		jQuery(".rt a").attr("data-title", function() { return jQuery(this).attr("title"); });
		jQuery(".rt a").removeAttr("title");
	}

	,filterCatalogReplace : function(){
		var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);
		var val = value.substring(value.lastIndexOf('?')); 

		collectionUrl = collectionUrl.replace(value, '');

		value = value.replace(val, '');
		value = value.replace('#', '');

		var value_arr = value.split('+');

		var current_arr = [];
		jQuery('#'+filter_id+' li.active-filter').each( function() {
		  current_arr.push(jQuery(this).attr('data-handle'));
		});

		jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
		jQuery('#'+filter_id+' li').removeClass('active-filter');

		for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
		  value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
		}

		var new_data = value_arr.join('+')

		var new_url = collectionUrl+new_data+val;

		window.location = new_url;
	}
  
	,filterCatalog : function(){
		var currentTags = '{{ current_tags }}'
			,filters 	= jQuery('.advanced-filter');

		filters.each(function() {
			var el = jQuery(this)
				,group = el.data('group');

			if ( el.hasClass('active-filter') ) { //Remove class hidden
				el.parents('.sb-filter').find('a.clear-filter').removeClass('hidden');
			}
		});

		filters.on('click', function() {
			var el 		= jQuery(this)
				,group 	= el.data('group')
				,url 	= el.find('a').attr('href');

			// Continue as normal if we're clicking on the active link
			if ( el.hasClass('active-filter') ) {
				return;
			}
		});

		jQuery('.sb-filter').on('click', '.clear-filter', function(n){ // Handle button clear

			var filter_id = jQuery(this).attr('id');
			filter_id = filter_id.replace('clear-', '');

			var collectionUrl = window.location.href;

			if(collectionUrl.match(/\?/)){
				var string = collectionUrl.substring(collectionUrl.lastIndexOf('?') - 1);

				if(string.match(/\//)){
					var str_replace = string.replace(/\//, '');
					collectionUrl = collectionUrl.replace(string, '');
					collectionUrl = collectionUrl+str_replace;
					AT_Main.filterCatalogReplace();
				}
				else{
					AT_Main.filterCatalogReplace();
				}
			}
			else{
				var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);

				collectionUrl = collectionUrl.replace(value, '');  

				value = value.replace('#', '');

				var value_arr = value.split('+');

				var current_arr = [];
				jQuery('#'+filter_id+' li.active-filter').each( function() {
				  current_arr.push(jQuery(this).attr('data-handle'));
				});

				jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
				jQuery('#'+filter_id+' li').removeClass('active-filter');

				for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
				  value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
				}

				var new_data = value_arr.join('+')

				var new_url = collectionUrl+new_data;

				window.location = new_url;
			}

		});
	}
	
	,swatch : function(){
        jQuery('.swatch :radio').change(function() {
          	var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
          	var optionValue = jQuery(this).val();
          	jQuery(this)
          	.closest('form')
          	.find('.single-option-selector')
          	.eq(optionIndex)
          	.val(optionValue)
          	.trigger('change');
        });
  	}

	,refreshImage : function(){ // Update product image in detail page
		if(jQuery('#gallery-image').length){

			jQuery('#product-image').on('click', '.thumb-img', function() {

				var jQuerythis = jQuery(this);

				if(!jQuerythis.hasClass('active')){
					var parent = jQuerythis.parents('.product-image-inner');
					var src_original = jQuerythis.attr('data-zoom-image');
					var src_display = jQuerythis.attr('data-image');

					parent.find('.thumb-img').removeClass('active');
					jQuerythis.addClass('active');

					parent.find('.featured-image').find('img').attr('data-zoom-image', src_original);
                 	parent.find('.featured-image').find('img').attr('src', src_display);
				}

				return false;
			});
		}
	}

	,refreshZoom : function(){ // Update Zoom in detail page
		var enable_zoom = jQuery('.featured-image').data('zoom');
		if((jQuery('.elevatezoom').length)){

			var zoomImage = jQuery('.elevatezoom .zoom-image');

			zoomImage.elevateZoom({
				gallery				:'gallery-image' 
				,galleryActiveClass	: 'active'
				,zoomType			: 'lens'
				,cursor				: 'pointer'
				,lensShape 			: "round"
				,lensSize 			: 300
			});

			//pass the images to Fancybox
			jQuery(".elevatezoom").bind("click", function(e) {  
				var ez =   jQuery('.elevatezoom .zoom-image').data('elevateZoom'); 
				jQuery.fancybox(ez.getGalleryList(),{
					closeBtn  : false,
					helpers : {
						buttons : {}
					}
				});
				return false;
			});
		}

	}

	,cartJS_handle : function() {
		//Bind cart json data to HTML
		rivets.bind(jQuery('.templateCart #cartform, .cart-right, .page-cart .cart-empty-wrapper, #cart-content'), {cart: CartJS.cart});
		
      //It's need to calculate from default currency to current currency that has chosen before
        if( typeof _bc_config === 'undefined' ){
          return;
        }
      	else{
        
          if( _bc_config.enable_multiple_currencies == 'true' ){
            setTimeout(function(){
            	Currency.convertAll('{{ settings.default_currency }}' , Currency.currentCurrency); 
            },50);                        
          }
                       
      	}

		//Handle when update to cart json completed
		jQuery(document).on('cart.requestComplete', function(event, cart) {
			Shopify.onCartUpdate(CartJS.cart);
              
            if( typeof _bc_config === 'undefined' ){
              return;
            }
              
            else{
              if( _bc_config.enable_multiple_currencies == 'true' ){
			    Currency.convertAll('{{ settings.default_currency }}' , Currency.currentCurrency);
               }
            }
		});
	}

    ,scareName : function(){
        if( jQuery('.cata-product.cp-grid, .home-tab .normal-product').length > 0 ){
          	var _name_height = 0;
            jQuery('.cata-product.cp-grid, .home-tab .normal-product').find('h5.product-name').each(function( index,value ){
                _name_height = jQuery(value).height() > _name_height ? jQuery(value).height() : _name_height;
            });
          	jQuery('.cata-product.cp-grid, .home-tab .normal-product').find('h5.product-name').css('height',_name_height);
        }
    }          
    ,scareScreen : function(){
      	if( typeof _bc_config == "undefined" ){
          	return;
      	}
      	var _current = this;
      
      	if( _bc_config.enable_title_blance == "true" ){
          	this.scareName();
      	}      
      	
      	jQuery( document ).ajaxComplete(function( event,request, settings ) {
          if( _bc_config.enable_title_blance == "true" ){
              _current.scareName();
          }  
        });  
    }               
              
	,init : function(){

      	this.stickMenu();
		this.toTopButton();
		this.mailchipPopup();
      	this.effectNavigation();
      	this.handleGridList();
        this.fixButton();
		this.menuOnMobile();
		this.handleMenuMultiLine();
		this.toggleFilterSidebar();
        this.toggleFooter();
      	this.toggleVerticalMenu();
		this.handleMap();
        //this.callPriceSlider();
		this.dropdownFilter();
		this.fixTitle();
		this.filterCatalog();
        this.swatch();
		this.refreshImage();
		this.refreshZoom();
		this.cartJS_handle();
        this.scareScreen();
	}
}
jQuery(".horizontal-menu .navigation .navbar-collapse .main-nav>li").hover(function(e){
  jQuery(this).find('>div span .dropdown-menu, >div span .dropdown-menu li >div span .dropdown-menu').addClass("fadeInUp animated");
},function(e){
  jQuery(this).find('>div span .dropdown-menu, >div span .dropdown-menu li >div span .dropdown-menu').removeClass("fadeInUp animated");
});
jQuery(".navbar .main-nav li").hover(function(){jQuery(this).addClass("hover")},function(){jQuery(this).removeClass("hover")});
jQuery(".navbar .main-nav li.without-dropdown").hover(function(){jQuery(this).parents('.dropdown.dropdown_hide').addClass("hover-without-dropdown")},function(){jQuery(this).parents('.dropdown.dropdown_hide').removeClass("hover-without-dropdown")});
jQuery(document).on('click','.mobile-version .menu-mobile .main-nav .expand',function(){
  var e=jQuery(this).parents(".dropdown").first();
  if (e.hasClass("menu-mobile-open")) {
    e.removeClass("menu-mobile-open");
    $(this).find('.visible-xs').removeClass('fa-minus');
    $(this).find('.visible-xs').addClass('fa-plus');
  } else {
    e.addClass("menu-mobile-open");
    $(this).find('.visible-xs').removeClass('fa-plus');
    $(this).find('.visible-xs').addClass('fa-minus');
  }
});
jQuery(document).on('click','.sb-categories .s-expand',function(){
  var e=jQuery(this).parents(".dropdown").first();
  if (e.hasClass("s-open")) {
    e.removeClass("s-open");
    $(this).find('.s-plus').removeClass('fa-angle-up');
    $(this).find('.s-plus').addClass('fa-angle-right');
  } else {
    e.addClass("s-open");
    $(this).find('.s-plus').removeClass('fa-angle-right');
    $(this).find('.s-plus').addClass('fa-angle-up');
  }
})
/* Handle when window resize */
jQuery(window).resize(function() {
          
	/* reset menu with condition */
	if(AT_Main.getWidthBrowser() < 1024){
		if(jQuery('#top').hasClass('on')){
			jQuery('#top').prev().remove();
			jQuery('#top').removeClass('on').removeClass('animated');
		}
	}

	/*Reset Page when fixNoScroll had called before*/
	AT_Main.fixReturnScroll();
	if(AT_Main.checkLayout() != 1 && jQuery('.menu-mobile').hasClass('opened'))
		jQuery("#page-body").trigger('click');
          
});
function quoteModalHide(){
  $("#quoteSuccess").addClass("zoomOut animated").fadeOut();
  $("#quoteSuccess").removeClass("zoomOut animated");
  $('html').removeClass('bg-quoteSuccess-body');
}
 /*
 
setTimeout(function() {
    jQuery('.templateCart #qs-add-cart').click(function(e){
      setTimeout(function(){
        window.location.reload();
      }, 2000);
    })
  
  	var $formState = $('.quote-successForm');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    dataLayer.push({
  event: 'quoteFormSubmitted',
  formType: 'quote',
  timestamp: new Date().toISOString()
});
  
    // show success message
    $('#quoteSuccess').show();
	 $('html').addClass('bg-quoteSuccess-body');
      
}, 1000);
*/

$(window).on('load resize orientationchange', function() {
   if(window.innerWidth < 999) {
$('.product-list.product-list--vertical').slick({
  responsive: [
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        speed:1200,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        speed:1200,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         speed:1200,
        infinite: false,
        dots: true
      }
    }
  ]
});
$('.featured-collection .product-list').slick({
  responsive: [
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        speed:1200,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        speed:1200,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         speed:1200,
        infinite: false,
        dots: true
      }
    }
  ]
});
$('.scroller .block-list').slick({
  responsive: [
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        speed:1200,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        speed:1200,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         speed:1200,
        infinite: false,
        dots: true
      }
    }
  ]
});
$('.collection-list').slick({
  responsive: [
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        speed:1200,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        speed:1200,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         speed:1200,
        infinite: false,
        dots: true
      }
    }
  ]
});

   }
});


 jQuery( document ).ready(function($) {
	
   jQuery('.abvlbilty-show-wrap .product-form__info-content').bind('DOMSubtreeModified', function(){
      var text_msg =  $(this).children('.product-form__inventory').text();
     if(text_msg && text_msg == "Re-stocking soon"){

        jQuery('#avblity_hide').css('display','flex');
      }
      if(text_msg && text_msg == "Sold out"){

          jQuery(this).parent().hide();
        jQuery('.product-bullets-icons').attr('id', 'avblity_bullet');
           jQuery('.product-bullets-icons').removeAttr('id');
       // jQuery(".product-each-logo").hide();
      }else{

          jQuery(this).parent().show();
        jQuery('.abvlbilty-show-wrap').removeAttr('id');
        // jQuery(".product-each-logo").show();
      }
        //console.log(text_msg);
  });
   
   /* Collection Tabs */
   $(document).on('click', '.js-collection-tabs__header__btn', function() {
     var $this = $(this);
     var $tabs = $this.parents('.collection-tabs');
     var $index = $this.attr('data-index');
     $tabs.find('.collection-tabs__header__btn').removeClass('collection-tabs__header__btn--active');
     $this.addClass('collection-tabs__header__btn--active');
     $tabs.find('.collection-tabs__body__item').removeClass('collection-tabs__body__item--active');
     $tabs.find(`.collection-tabs__body__item[data-index="${$index}"]`).addClass('collection-tabs__body__item--active');
   });
   
   // Package popup
   $(document).on('click', '.js-package-popup__trigger', function (e) {
     e.preventDefault();
     $('.package-popup').addClass('package-popup--active');
   });

   $(document).on('click', '.js-package-popup__close', function () {
     $('.package-popup').removeClass('package-popup--active');
   });

   $(document).on('click', '.js-package-popup__overlay', function () {
     $('.package-popup').removeClass('package-popup--active');
   });
   
   /* Colletion Meta Tabs */
   $(document).on('click', '.col-meta__title__item', function () {
     var $this = $(this);
     var $tabs = $this.parents('.col-meta');
     var index = $this.attr('data-index');
     $tabs.find('.active').removeClass('active');
     $this.addClass('active');
     $tabs.find(`.col-meta__content__item[data-index="${index}"]`).addClass('active');
   });
   
   $('.col-meta__content__item').each(function () {
     var flag = $(this).hasClass('active')
     if (!flag) {
       $(this).addClass('active');
     }
     if ($(this)[0].scrollHeight > 240) {
       $(this).append('<a class="read-more"><svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation"><path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>    </svg><span>Read More</span></a>');
     }
     if (!flag) {
       $(this).removeClass('active');
     }
   });
   
   $(document).on('click', '.read-more', function () {
     var $content_item = $(this).parents('.col-meta__content__item');
     if ($(this).hasClass('read-less')) {
       $(this).removeClass('read-less');
       $(this).find('span').text('Read More');
       $(this).parent().css('max-height', '240px');
     }
     else {
       $(this).addClass('read-less');
       $(this).find('span').text('Read Less');
       $(this).parent().css('max-height', $content_item[0].scrollHeight + 'px');
     }
   });
   
   $(document).on('click', '.js-manufacture-tabs__title__item', function () {
     var index = $(this).attr('data-index');
     $('.manufacture-tabs__title__item--active').removeClass('manufacture-tabs__title__item--active');
     $('.manufacture-tabs__content__item--active').removeClass('manufacture-tabs__content__item--active');
     $(`.manufacture-tabs__title__item[data-index=${index}]`).addClass('manufacture-tabs__title__item--active');
     $(`.manufacture-tabs__content__item[data-index=${index}]`).addClass('manufacture-tabs__content__item--active');
     $('.manufacture-tabs__content__item--active .product-list').slick('reinit');
   });
   
   $(document).on('click', '.post-header__link', function() {
     var id = $(this).attr('href');
     var aTag = $(id);
     $('html,body').animate({scrollTop: aTag.offset().top - 120},'slow');
   });
});
         